import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldRow } from '../ui';

// Field content only — the parent wraps this in EntityDrawer.
const GAUserForm = ({ form, setForm, errors = {} }) => {
  const { t } = useTranslation();
  return (
    <>
      <FieldRow label={t('ga.company.username')} error={errors.username} required>
        <TextField fullWidth value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} error={Boolean(errors.username)} />
      </FieldRow>
      <FieldRow label={t('ga.company.email')} error={errors.email} required>
        <TextField fullWidth value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} error={Boolean(errors.email)} />
      </FieldRow>
      <FieldRow label={t('ga.company.role')}>
        <TextField select fullWidth value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
          <MenuItem value="user">{t('ga.company.roleUser')}</MenuItem>
          <MenuItem value="admin">{t('ga.company.roleAdmin')}</MenuItem>
          <MenuItem value="global_admin">{t('ga.company.roleGlobal')}</MenuItem>
        </TextField>
      </FieldRow>
      <FieldRow label={t('ga.company.language')}>
        <TextField fullWidth value={form.preferredLanguage} onChange={(e) => setForm({ ...form, preferredLanguage: e.target.value })} />
      </FieldRow>
    </>
  );
};

export default GAUserForm;
